import { FC, Fragment } from 'react';
import { HTHBuildingModalCheckbox } from './HTHBuildingModalCheckbox';
import { hthConfigOptions } from 'src/app-config';
import { typeHTHBuilding, typeHTHHousehold } from '@monorepo/models';

type propsType = {
    currentBuilding: typeHTHBuilding;
    onClickHandler: (currentHousehold: typeHTHHousehold) => void;
};

export const HTHBuildingModalSimple: FC<propsType> = ({ currentBuilding, onClickHandler }) => {
    const manager = currentBuilding.households.find(h => h.isManager);

    return (
        <div className={'my-3'}>
            <div className={'overflow-auto'}
                style={{ display: 'flex', flexDirection: currentBuilding.reverseOrderY ? 'column' : 'column-reverse' }}
            >
                {hthConfigOptions.buildingLevels
                 .slice(currentBuilding.hasLowLevel ? 0 : 1, currentBuilding.numberOfLevels + 1)
                 .map(level =>
                    <div key={level}>
                        <div className={`row d-flex justify-content-${currentBuilding.numberPerLevel === 1 ? 'center' : 'start'} align-self-center flex-nowrap my-1`}
                            style={{
                                marginLeft: currentBuilding.numberPerLevel >= 3 ? '10px' : currentBuilding.numberPerLevel === 1 ? '0' : '50px'
                            }}
                        >
                            {hthConfigOptions.buildingDoorNumbers
                             .slice(0, currentBuilding.numberPerLevel)
                             .sort((dn1, dn2) => currentBuilding.reverseOrderX ? dn2 - dn1 : dn1 - dn2)
                             .map(doorNumber => {
                                // no need to filter managers because level and doorNumber are always null
                                const currentHousehold = currentBuilding.households.find(x => x.level === level && x.doorNumber === doorNumber);
                                if (!currentHousehold) {
                                    return (
                                        <Fragment key={level + '-' + doorNumber}></Fragment>
                                    );
                                }
                                return (
                                    <HTHBuildingModalCheckbox key={level + '-' + doorNumber}
                                        currentHousehold={currentHousehold}
                                        isComplexBuilding={false}
                                        onClickHandler={onClickHandler}
                                    />
                                )
                            })}
                        </div>
                    </div>
                )}
            </div>
            {manager &&
                <div className={'row d-flex justify-content-center align-self-center mt-2 mb-3 mx-1'}>
                    <HTHBuildingModalCheckbox
                        currentHousehold={manager}
                        isComplexBuilding={false}
                        onClickHandler={onClickHandler}
                    />
                </div>
            }
        </div>
    );
}
